<template>
  <div>

    <b-row>
      <b-col>
        <b-button @click="toPage('/master-flow-approval')" variant="outline-primary">kembali</b-button>
      </b-col>
    </b-row>

    <div>&nbsp;</div>

    <b-row>
      <b-col cols="6" xl="6">
        <table class="table table-sm table-borderless">
          <tbody>
            <tr>
              <th class="pl-0"><span class="fw-bold">Jenis Modul</span></th>
              <td>{{ flowApproval.moduleType }}</td>
            </tr>
            <tr>
              <th class="pl-0"><span class="fw-bold">Implement Role</span></th>
              <td>{{ flowApproval.roleImplement ? flowApproval.roleImplement.roleName : '-' }}</td>
            </tr>
            <tr>
              <th class="pl-0"><span class="fw-bold">Total Approval</span></th>
              <td>{{ flowApproval.totalApproval }}</td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>

    <div>&nbsp;</div>

    <b-row>
      <b-col md="4" class="mb-1">
        <!-- <b-form-input placeholder="Cari" v-model="filter.title" /> -->
      </b-col>
      <b-col class="mb-1 text-right">
        <FormFlowApprover
          :is-loading="isLoading"
          :edit-id="editId"
          :validations="validations"
          :create-item="createItem"
          :update-item="updateItem"
          :clean-up-form="cleanUpForm"
          :form-payload="formPayload"
          :role="role"
          @payloadFlowApprover="getPayload($event)"
        />
      </b-col>
    </b-row>

    <ListFlowApprover
      :result="result"
      :is-loading="isLoading"
      :edit-item="editItem"
      :delete-item="deleteItem"
      :detail-item="detailItem"
    />

    <DetailFlowApprover :result="detail" />

  </div>
</template>

<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";
import {
  BButton,
  BSpinner,
  BFormInput,
  BFormFile,
  BFormCheckbox,
  BFormSelect,
  BFormTextarea,
  BImg,
  BRow,
  BCol,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { successNotification, errorNotification } from "@/auth/utils";

import ListFlowApprover from "@/components/FlowApproval/FlowApprover/ListFlowApprover.vue";
import DetailFlowApprover from "@/components/FlowApproval/FlowApprover/DetailFlowApprover.vue";
import FormFlowApprover from "@/components/FlowApproval/FlowApprover/FormFlowApprover.vue";

export default {
  components: {
    BButton,
    BSpinner,
    BFormInput,
    BFormCheckbox,
    BFormFile,
    BFormSelect,
    BImg,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    required,
    BRow,
    BCol,
    ListFlowApprover,
    DetailFlowApprover,
    FormFlowApprover,
  },
  directives: {
    Ripple,
  },
  watch: {
    filter: {
      handler: _.debounce(function (value) {
        this.getEmployeeJobData();
      }, 300),
      deep: true,
    },
  },
  data() {
    return {
      isLoadingFlowApproval: false,
    };
  },
  setup(props) {
    return {
      successNotification,
      errorNotification,
    };
  },
  data() {
    return {
      result: {},
      isLoading: false,
      validations: {},
      formPayload: Object,
      editId: null,
      detail: {},
      filter: {
        employeeName: "",
      },
      id: this.$route.params.id,
      flowApproval: Object,
      role: Array
    };
  },
  created() {
    this.getDetail()
    this.getData()
    this.getRoleData()
  },
  methods: {
    toPage(page) {
      this.$router.push(page);
    },
    getPayload(value) {
      if (value) {
        this.formPayload = value;
      }
    },
    cleanUpForm() {
      this.editId = null;
      this.formPayload = {
        approvalType: 0,
        flowRulesId: this.id,
        sequenceApproval: 0,
        top: true
      };
      this.validations = "";
    },
    detailItem(item) {
      this.detail = item;
      this.$bvModal.show('form-detail-flow-approver-modal')
    },
    createItem() {
      this.getPayload();
      const form = this.formPayload
      this.isLoading = true;

      this.$http
        .post("/mastering/flowApprover", form, {
          headers: { "content-type": "application/json" },
        })
        .then((response) => {
          if (response.data.code !== '00' ) {
            errorNotification(this, "Oops!", response.data.message);
          } else {
            this.$bvModal.hide("form-flow-approver-modal");
            this.getData();
            successNotification(this, "Success", "Approval berhasil di buat");
            this.cleanUpForm();
          }
          
          this.isLoading = false;
        })
        .catch((error) => {
          errorNotification(this, "Oops!", error.response.data.message);

          this.isLoading = false;
        });
    },
    updateItem() {
      const form = this.formPayload
      this.isLoading = true;
      // form.append('_method', 'PUT')

      this.$http
        .put(`/mastering/flowApprover/${this.editId}`, form, {
          headers: { "content-type": "application/json" },
        })
        .then((response) => {
          if (response.data.code !== '00' ) {
            errorNotification(this, "Oops!", response.data.message);
          } else {
            this.$bvModal.hide("form-flow-approver-modal");
            this.getData();
            successNotification(this, "Success", "Approval berhasil di ubah!");
            this.cleanUpForm();
          }
          
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.data.meta.validations) {
            this.validations = error.response.data.meta.validations;
            errorNotification(this, "Oops!", error.response.data.meta.messages);
          }
          this.isLoading = false;
        });
    },
    preparePayload() {
      const form = new FormData();
      for (const key in this.formPayload) {
        if (
          this.formPayload.hasOwnProperty(key) &&
          this.formPayload[key] != null
        ) {
          form.append(key, this.formPayload[key]);
        }
      }

      return form;
    },
    editItem(item) {
      this.cleanUpForm();
      this.editId = item.id;
      this.formPayload = {
        approvalType: item.approvalType ? item.approvalType.roleId : item.approvalType,
        flowRulesId: item.flowRule ? item.flowRule.flowRulesId : item.flowRule,
        sequenceApproval: item.sequenceApproval,
        top: item.top
      };
      this.$bvModal.show("form-flow-approver-modal");
      // this.$bvModal.show('form-detail-flow-approver-modal')
    },
    deleteItem(id) {
      this.$swal({
        title: "Anda yakin?",
        text: "Anda yakin ingin menghapus data ini?",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$http
            .delete(`/mastering/flowApprover/${id}`)
            .then((response) => {
              this.getData(this.currentPage);
              this.$swal({
                icon: "success",
                title: "Berhasil!",
                text: "Approval berhasil di hapus",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
            }) 
            .catch((error) => {
              console.log("error");
              console.log(error);
              // if (error.response.data.meta.messages.length > 0) {
              //   errorNotification(this, 'Oops!', error.response.data.meta.messages)
              // }
            });
        }
      });
    },
    getDetail() {
      this.$http
        .get("/mastering/flowRule/" + this.id)
        .then((response) => {
          this.flowApproval = response.data.data
          console.log(this.flowApproval)
        });
    },
    getData(page = 1) {
      this.isLoading = true;
      const queryParams = this.filter;
      queryParams.page = page;
      queryParams.flowRulesId = this.id;

      this.$http
        .get("/mastering/flowApprover/findAll", {
          params: queryParams,
        })
        .then((response) => {
          this.result = response.data.data;
          this.isLoading = false;
        });
    },
    getRoleData() {
      this.$http.get("role", {  }).then((response) => {
        let result = response.data.data;

        for (let i = 0; i < result.length; i++) {
          result[i].value = result[i].roleId;
          result[i].text = result[i].roleName;
          delete result[i].key;
          delete result[i].label;
        }

        this.role = result;
      });
    },
  },
};
</script>
